import { Component, OnInit } from '@angular/core';

import { fciWebsiteService } from '../../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CustomServiceService } from './../../../service/custom-service.service';
import { EncryptDecryptService } from './../../../service/encrypt-decrypt.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
declare let $: any;
import * as CryptoJS from 'crypto-js';
import { Buffer } from 'buffer';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-news-tenders',
  templateUrl: './news-tenders.component.html',
  styleUrls: ['./news-tenders.component.css'],
})
export class NewsTendersComponent implements OnInit {
  constructor(
    private fciwebservice: fciWebsiteService,
    private httpservice: CustomServiceService,
    private encDec: EncryptDecryptService,
    private route: Router,
    public translate: TranslateService
  ) { }
  imageUrl = environment.serviceURL + 'storage/app/uploads/';
  backendUrl = environment.serviceURL;
  backend_url: any = environment.serviceURL;
  language: any = '';
  CURRENT_ZONE_ID: any = environment.ZONE_ID;
  CURRENT_REGION_ID: any = environment.REGION_ID;
  CURRENT_ZONE_CODE: any = environment.ZONE_CODE;
  CURRENT_REGION_CODE: any = environment.REGION_CODE;
  datetime: any = this.httpservice.currentDateTime();

  ngOnInit(): void {
    this.getDivision();
    this.language = sessionStorage.getItem('locale'); //dynamic
    this.getNewsList();
    this.tenderlist();
  }

  content_apiresponse: any;
  mediaResponse: any;
  newsList: any = [];
  pressReleaseList: any = [];
  awardsList: any = [];
  circularList: any = [];
  newsLength: any;
  getNewsList() {
    let params = [
      {
        secSlNo: 1,
        offSet: 0,
        noOfRecords: 10,
        orderBy: [{ columnName: 'VCHPUBLISH_DATE', type: 'DESC' }],
        condition: [
          {
            columnName: 'VCHPUBLISH_DATE',
            operator: '<=',
            value: new Date(),
            joinoperator: 'and',
          },
          {
            columnName: 'VCHACH_DATE',
            operator: '>',
            value: new Date(),
            joinoperator: 'and',
          },
          {
            columnName: 'VCHMEDIA_TYPE',
            operator: '=',
            value: 3,
            joinoperator: 'and',
          },
          {
            columnName: 'bitDeletedFlag',
            operator: '=',
            value: 0,
            joinoperator: 'and',
          },
          {
            columnName: 'tinPublishStatus',
            operator: '=',
            value: 1,
            joinoperator: 'and',
          },
          {
            columnName: 'ZONE_ID',
            operator: '=',
            value: environment.ZONE_ID,
            joinoperator: 'and',
          },
        ],
        viewParameters: '',
      },
    ];
    this.fciwebservice
      .getAllMediaType(params)
      .subscribe((response: HttpEvent<any>) => {
        switch (response.type) {
          case HttpEventType.Sent:
            break;
          case HttpEventType.ResponseHeader:
            break;
          case HttpEventType.UploadProgress:
            break;
          case HttpEventType.Response:
            this.content_apiresponse = response.body;
            let respData = this.content_apiresponse.RESPONSE_DATA;
            let respToken = this.content_apiresponse.RESPONSE_TOKEN;
            let verifyToken = CryptoJS.HmacSHA256(
              respData,
              environment.apiHashingKey
            ).toString();
            if (respToken == verifyToken) {
              let response: any = Buffer.from(respData, 'base64');
              response = JSON.parse(response);
              this.mediaResponse = response.result.sec_1;
              this.newsList = [];
              this.newsList = this.mediaResponse;
              this.newsLength = this.newsList.length;
            }
        }
      });
  }
  pressReleaseLength: any;
  getPressReleaseList() {
    let params = [
      {
        secSlNo: 1,
        offSet: 0,
        noOfRecords: 10,
        orderBy: [{ columnName: 'VCHPUBLISH_DATE', type: 'DESC' }],
        condition: [
          {
            columnName: 'VCHPUBLISH_DATE',
            operator: '<=',
            value: new Date(),
            joinoperator: 'and',
          },
          {
            columnName: 'VCHACH_DATE',
            operator: '>',
            value: new Date(),
            joinoperator: 'and',
          },
          {
            columnName: 'VCHMEDIA_TYPE',
            operator: '=',
            value: 4,
            joinoperator: 'and',
          },
          {
            columnName: 'bitDeletedFlag',
            operator: '=',
            value: 0,
            joinoperator: 'and',
          },
          {
            columnName: 'tinPublishStatus',
            operator: '=',
            value: 1,
            joinoperator: 'and',
          },
          {
            columnName: 'ZONE_ID',
            operator: '=',
            value: environment.ZONE_ID,
            joinoperator: 'and',
          },
        ],
        viewParameters: '',
      },
    ];
    this.fciwebservice
      .getAllMediaType(params)
      .subscribe((response: HttpEvent<any>) => {
        switch (response.type) {
          case HttpEventType.Sent:
            break;
          case HttpEventType.ResponseHeader:
            break;
          case HttpEventType.UploadProgress:
            break;
          case HttpEventType.Response:
            this.content_apiresponse = response.body;
            let respData = this.content_apiresponse.RESPONSE_DATA;
            let respToken = this.content_apiresponse.RESPONSE_TOKEN;
            let verifyToken = CryptoJS.HmacSHA256(
              respData,
              environment.apiHashingKey
            ).toString();
            if (respToken == verifyToken) {
              let response: any = Buffer.from(respData, 'base64');
              response = JSON.parse(response);
              this.mediaResponse = [];
              this.mediaResponse = response.result.sec_1;
              this.pressReleaseList = this.mediaResponse;
              this.pressReleaseLength = this.pressReleaseList.length;
            }
        }
      });
  }
  awardsListLength: any;
  getAwardsList() {
    let params = [
      {
        secSlNo: 1,
        offSet: 0,
        noOfRecords: 10,
        orderBy: [{ columnName: 'dtmCreatedOn', type: 'DESC' }],
        condition: [
          {
            columnName: 'VCHARCHIVEDATE',
            operator: '>',
            value: new Date(),
            joinoperator: 'and',
          },
          {
            columnName: 'INT_TYPE',
            operator: '=',
            value: 7,
            joinoperator: 'and',
          },
          {
            columnName: 'bitDeletedFlag',
            operator: '=',
            value: 0,
            joinoperator: 'and',
          },
          {
            columnName: 'tinPublishStatus',
            operator: '=',
            value: 1,
            joinoperator: 'and',
          },
          {
            columnName: 'ZONE_ID',
            operator: '=',
            value: environment.ZONE_ID,
            joinoperator: 'and',
          },
        ],
        viewParameters: '',
      },
    ];
    this.fciwebservice
      .getAwardEvent(params)
      .subscribe((response: HttpEvent<any>) => {
        switch (response.type) {
          case HttpEventType.Sent:
            break;
          case HttpEventType.ResponseHeader:
            break;
          case HttpEventType.UploadProgress:
            break;
          case HttpEventType.Response:
            this.content_apiresponse = response.body;
            let respData = this.content_apiresponse.RESPONSE_DATA;
            let respToken = this.content_apiresponse.RESPONSE_TOKEN;
            let verifyToken = CryptoJS.HmacSHA256(
              respData,
              environment.apiHashingKey
            ).toString();
            if (respToken == verifyToken) {
              let response: any = Buffer.from(respData, 'base64');
              response = JSON.parse(response);
              this.mediaResponse = [];
              this.mediaResponse = response.result.sec_1;
              this.awardsList = this.mediaResponse;
              this.awardsListLength = this.awardsList.length;
            }
        }
      });
  }
  circularLength: any;
  getCircularList() {
    let params = [
      {
        secSlNo: 1,
        offSet: 0,
        noOfRecords: 10,
        orderBy: [{ columnName: 'VCHPUBLISH_DATE', type: 'DESC' }],
        condition: [
          {
            columnName: 'VCHPUBLISH_DATE',
            operator: '<=',
            value: new Date(),
            joinoperator: 'and',
          },
          {
            columnName: 'VCHACH_DATE',
            operator: '>',
            value: new Date(),
            joinoperator: 'and',
          },
          {
            columnName: 'VCHMEDIA_TYPE',
            operator: '=',
            value: 6,
            joinoperator: 'and',
          },
          {
            columnName: 'bitDeletedFlag',
            operator: '=',
            value: 0,
            joinoperator: 'and',
          },
          {
            columnName: 'tinPublishStatus',
            operator: '=',
            value: 1,
            joinoperator: 'and',
          },
          {
            columnName: 'ZONE_ID',
            operator: '=',
            value: environment.ZONE_ID,
            joinoperator: 'and',
          },
        ],
        viewParameters: '',
      },
    ];
    this.fciwebservice
      .getAllMediaType(params)
      .subscribe((response: HttpEvent<any>) => {
        switch (response.type) {
          case HttpEventType.Sent:
            break;
          case HttpEventType.ResponseHeader:
            break;
          case HttpEventType.UploadProgress:
            break;
          case HttpEventType.Response:
            this.content_apiresponse = response.body;
            let respData = this.content_apiresponse.RESPONSE_DATA;
            let respToken = this.content_apiresponse.RESPONSE_TOKEN;
            let verifyToken = CryptoJS.HmacSHA256(
              respData,
              environment.apiHashingKey
            ).toString();
            if (respToken == verifyToken) {
              let response: any = Buffer.from(respData, 'base64');
              response = JSON.parse(response);
              this.mediaResponse = [];
              this.mediaResponse = response.result.sec_1;
              this.circularList = this.mediaResponse;
              this.circularLength = this.circularList.length;
            }
        }
      });
  }

  c_apirespons: any;
  current_data: any[] = [];
  RecruitmentLength: any;
  Recruitment() {
    let params = [
      {
        secSlNo: 1,
        offSet: 0,
        noOfRecords: 10,
        orderBy: [{ columnName: 'PUBLISH_DATE', type: 'DESC' }],
        condition: [
          {
            columnName: 'tinPublishStatus',
            operator: '=',
            value: 1,
            joinoperator: 'and',
          },
          {
            columnName: 'bitDeletedFlag',
            operator: '=',
            value: 0,
            joinoperator: 'and',
          },
          {
            columnName: 'ZONE_ID',
            operator: '=',
            value: environment.ZONE_ID,
            joinoperator: 'and',
          },
        ],
        viewParameters: '',
      },
    ];
    this.httpservice
      .GetCurrnetRecruitment(params)
      .subscribe((response: HttpEvent<any>) => {
        switch (response.type) {
          case HttpEventType.Sent:
            break;
          case HttpEventType.ResponseHeader:
            break;
          case HttpEventType.UploadProgress:
            break;
          case HttpEventType.Response:
            this.c_apirespons = response.body;
            let respData = this.c_apirespons.RESPONSE_DATA;
            let respToken = this.c_apirespons.RESPONSE_TOKEN;
            let verifyToken = CryptoJS.HmacSHA256(
              respData,
              environment.apiHashingKey
            ).toString();
            if (respToken == verifyToken) {
              let response: any = Buffer.from(respData, 'base64');
              response = JSON.parse(response);
              this.current_data = [];
              this.current_data = response.result.sec_1;
              this.RecruitmentLength = this.current_data.length;
            }
        }
      });
  }

  division_apirespons: any;
  divisionList: any[] = [];

  getDivision() {
    var query: any = [
      { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
      { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
      { "columnName": "DIVISION_TYPE", "operator": "in", "value": '2,4', "joinoperator": "and" }
    ];
    // if(environment.ZONE_ID  > 0){
    //     query.push({ "columnName": "ZONE_ID", "operator": "=", "value": environment.ZONE_ID, "joinoperator": "and" });
    // }
    let params = [{
      "secSlNo": 1,
      "offSet": 0,
      "noOfRecords": 0,
      "orderBy": [{ "columnName": "VCHDIVISIONEN", "type": "ASC" }],
      "condition": query,
      "viewParameters": ""
    }];
    this.httpservice.getDivisionList(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.division_apirespons = response.body;
          let respData = this.division_apirespons.RESPONSE_DATA;
          let respToken = this.division_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            if (res.status == 200) {
              this.divisionList = res.result.sec_1;
              // console.log(this.divisionList);
            }
          }
      }
    })
  }


  getDivisionName(data: any): any {
    let d = '';
    this.divisionList.forEach((element: any) => {
      if (element.id == data.chooseDivision) {
        if (this.language == 'English') {
          d = this.htmlTag(element.name);
        } else {
          d = this.htmlTag(element.nameInHindi);
        }
      }



    });

    return d;
  }

  t_apirespons: any;
  tenderList: any = [];
  tenderLength: any;
  tenderlist() {
    let params = [
      {
        secSlNo: 1,
        offSet: 0,
        noOfRecords: 10,
        orderBy: [{ "columnName": "intId", "type": "DESC" }],
        condition: [
          {
            columnName: 'ZONE_ID',
            operator: '=',
            value: environment.ZONE_ID,
            joinoperator: 'and',
          },
          {
            columnName: 'TYPE',
            operator: '=',
            value: '1',
            joinoperator: 'and',
          },
          // { "columnName": "PUBLISH_DATE", "operator": "<=", "value": this.datetime.date, "joinoperator": "and" },
          // { "columnName": "PUBLISH_TIME", "operator": "<=", "value": this.datetime.HM+':00', "joinoperator": "and" },
          {
            columnName: 'tinPublishStatus',
            operator: '=',
            value: '1',
            joinoperator: 'and',
          },
          {
            columnName: 'bitDeletedFlag',
            operator: '=',
            value: '0',
            joinoperator: 'and',
          },
          {
            rawQuery: `'${this.datetime.date} ${this.datetime.HM + ':00'
              }' >= DATE_FORMAT(concat_ws(' ',SD.PUBLISH_DATE,SD.PUBLISH_TIME), '%Y-%m-%d %H:%i:%s') AND '${this.datetime.date
              } ${this.datetime.HM + ':00'
              }' < DATE_FORMAT(concat_ws(' ',SD.VCHARCHIVEDATE,SD.ARCHIVE_TIME), '%Y-%m-%d %H:%i:%s')`,
          },
        ],
        viewParameters: '',
      },
    ];

    this.httpservice
      .getTenderlist(params)
      .subscribe((response: HttpEvent<any>) => {
        switch (response.type) {
          case HttpEventType.Sent:
            break;
          case HttpEventType.ResponseHeader:
            break;
          case HttpEventType.UploadProgress:
            break;
          case HttpEventType.Response:
            this.t_apirespons = response.body;
            let respData = this.t_apirespons.RESPONSE_DATA;
            let respToken = this.t_apirespons.RESPONSE_TOKEN;
            let verifyToken = CryptoJS.HmacSHA256(
              respData,
              environment.apiHashingKey
            ).toString();
            if (respToken == verifyToken) {
              let response: any = Buffer.from(respData, 'base64');
              response = JSON.parse(response);
              this.tenderList = response.result.sec_1;
              this.tenderLength = this.tenderList.length;
            }
        }
      });
  }
  htmlTag(data: any) {
    return this.encDec.decodeHtml(data);
  }

  jsonConvert(data: any, type: any) {

    if (data == '' || data == null) {
      return '';
    }
    let d = JSON.parse(data.jsonOptTxtDetails);
    if (d == '' || d == null) {
      return '';
    }
    if (type == 'ZONE_ID') {
      return d.ZONE_ID;
    } else if (type == 'LINK_ID') {
      return d.LINK_ID;
    } else if (type == 'REGION_ID') {
      return d.REGION_ID;
    } else if (type == 'DIVISION_ID') {
      return d.DIVISION_ID;
    } else if (type == 'CATEGORY') {
      return this.categoryLanguage(data.category);
    } else {
      return '';
    }
  }

  goToExtLink(url: any) {
    Swal.fire({
      title:
        'You are being redirected to an external website. Please note that Food Corporation of India (FCI) cannot be held responsible for external websites content & privacy policies.',
      text: 'Are you sure?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        window.open(url, '_blank');
      }
    });
  }

  viewDetails(id: any, pageName: any) {
    let encSchemeStr = this.encDec.encText(id.toString());
    this.route.navigate(['./' + pageName + '/', encSchemeStr]);
  }

  viewMore(pageName: any) {
    let url = './' + pageName;
    this.route.navigate([pageName]);
  }

  htmldecode(str: any) {
    return this.encDec.decodeHtml(str);
  }

  encriptdata(id: any) {
    return this.encDec.encText(id.toString());
  }

  CheckFile(f: any): boolean {
    if (f?.fileSize == '') {
      return false;
    } else {
      return true;
    }
  }

  viewTenderDetails(id: any, pageName: any) {
    let encSchemeStr = this.encDec.encText(`${id.toString()}:false`);
    this.route.navigate(['/' + pageName + '/', encSchemeStr]);
  }

  categoryLanguage(id: any): any {
    if (id == 1) {
      return this.language == 'English' ? 'Category I' : 'वर्ग १';
    } else if (id == 2) {
      return this.language == 'English' ? 'Category II' : 'वर्ग २';
    } else if (id == 3) {
      return this.language == 'English' ? 'Category III' : 'वर्ग ३';
    } else if (id == 4) {
      return this.language == 'English' ? 'Category IV' : 'वर्ग ४';
    }
    return "";
  }

}
